/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Container, CssBaseline, Fab, Fade, Link, Toolbar, Typography, useScrollTrigger } from "@mui/material";
import React from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./MobileLayout.scss";
import MobileLayoutFooter from "../core/footer/MobileLayoutFooter";
import MobileLayoutHeader from "../core/header/MobileLayoutHeader";
import MobileppContent from "../core/appContent/MobileAppContent";

interface Props {
  window?: () => Window;
  children: React.ReactElement;
}

function ScrollTop(props: Props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = ((event.target as HTMLDivElement).ownerDocument || document).querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box onClick={handleClick} role="presentation" sx={{ position: "fixed", bottom: 90, right: 16 }}>
        {children}
      </Box>
    </Fade>
  );
}

const MobileLayout = () => {
  return (
    <>
      <div>
        <CssBaseline />
        <MobileLayoutHeader />
        <Container>
          <Toolbar id="back-to-top-anchor" />
          <Box sx={{ my: 2, overflow: "auto" }}>
            <Typography variant="subtitle2" fontWeight="400" textAlign="center">
              For questions and to learn more about our custom reports{" "}
              <Link href="mailto:contact@employersforumindiana.org" underline="always">
              contact@employersforumindiana.org
              </Link>
            </Typography>
            <MobileppContent />
          </Box>
          <Box>
            <ScrollTop>
              <Fab size="small" aria-label="scroll back to top">
                <KeyboardArrowUpIcon />
              </Fab>
            </ScrollTop>
          </Box>
        </Container>
        {/* <MobileLayoutFooter /> */}
      </div>
    </>
  );
};

export default MobileLayout;
